import { FileCardGallery } from 'services';
import { create } from 'zustand';

type ViewType = 'cards' | 'list';

type Store = {
  viewType: ViewType;
  setViewType: (viewType: ViewType) => void;
  selectedFileToView?: FileCardGallery;
  selectedImageToView?: FileCardGallery;
  setSelectedFileToView: (file?: FileCardGallery) => void;
  setSelectedImageToView: (file?: FileCardGallery) => void;
};

export const useFilesGalleyStore = create<Store>()((set, _get) => ({
  viewType: 'cards',
  setViewType: (viewType: ViewType) => set({ viewType }),
  setSelectedFileToView: (file?: FileCardGallery) => set({ selectedFileToView: file }),
  selectedFileToView: undefined,
  setSelectedImageToView: (file?: FileCardGallery) => set({ selectedImageToView: file }),
  selectedImageToView: undefined,
}));

export const useFilesGalleryViewType = () => useFilesGalleyStore((state) => state.viewType);
export const useSetFilesGalleryViewType = () => useFilesGalleyStore((state) => state.setViewType);
export const useSelectedFileToView = () => useFilesGalleyStore((state) => state.selectedFileToView);
export const useSetSelectedFileToView = () => useFilesGalleyStore((state) => state.setSelectedFileToView);
export const useSelectedImageToView = () => useFilesGalleyStore((state) => state.selectedImageToView);
export const useSetSelectedImageToView = () => useFilesGalleyStore((state) => state.setSelectedImageToView);
